import Vue from 'vue'
import Router from 'vue-router'

import home from '@/components/home'
import home_parent from '@/components/common_page/home_parent'


Vue.use(Router)

// RouterTab 内置路由
import { RouterTabRoutes } from 'omnis-vue-router-tab'

export default new Router({
  mode: 'history',
  routes: [

    {
      path: '/monitoring_center/monitor_big_dish/monitor_screen',
      name: 'monitor_screen',
      component: resolve => {
        require(['@/components/monitoring_center/monitor_big_dish/monitor_screen'], resolve)
      },
      meta: {
        title: "云监控",
        tips: "云监控"
      }
    },

    {
      path: '/monitoring_center/monitor_big_dish/database_delay',
      name: 'database_delay',
      component: resolve => {
        require(['@/components/monitoring_center/monitor_big_dish/database_delay'], resolve)
      },
      meta: {
        title: "数据库延时",
        tips: "数据库延时"
      }
    },

    {
      path: '/asset_operations/asset_management_tmp2',
      name: 'asset_operations_tmp2',
      component: resolve => {
        require(['@/components/assets_operations/asset_management/asset_management_tmp2'], resolve)
      },
      meta: {
        title: "组件示例",
        tips: "组件示例"
      }
    },
    {
      path: '/',
      redirect: '/home'

    },
    {
      path: '/req_omnis/:edit_type/:req_id',
      name: 'edit_consheet_information',
      component: resolve => {
        require(['@/components/release_management/consheet_list/edit_consheet_information'], resolve)
      },
      meta: {
        title: "升级单详情",
        tips: "升级单详情"
      }
    },

    {
      path: '/req_omnis/:edit_type/:req_id/:req_statu',
      name: 'edit_consheet_information',
      component: resolve => {
        require(['@/components/release_management/consheet_list/edit_consheet_information'], resolve)
      },
      meta: {
        title: "升级单编辑页面",
        tips: "升级单编辑页面"
      }
    },

    {
      path: '/req_omnis/:edit_type',
      name: 'edit_consheet_information',
      component: resolve => {
        require(['@/components/release_management/consheet_list/edit_consheet_information'], resolve)
      },
      meta: {
        title: "升级单新增页面",
        tips: "升级单新增页面"
      }
    },
    {
      path: '/oracle_report_omnis/:oracle_rpt_id',
      name: 'report_content',
      component: resolve => {
        require(['@/components/efficient_devops/oracle_report/report_content'], resolve)
      },
      meta: {
        title: "Oracle报告详情",
        tips: "Oracle报告详情"
      }
    },


    {
      path: '/omnis_fort_service/websql_audit',
      name: 'omnis_fort_service',
      component: resolve => {
        require(['@/components/fort_service/websql_audit/index'], resolve)
      },
      meta: {
        title: "查看历史",
        tips: "查看历史"
      }
    },
    {
      path: '/system/login',
      name: 'login',
      component: resolve => {
        require(['@/components/system/login'], resolve)
      },
    },
    {
      path: "/omnis_parent",
      name: "omnis_parent",
      component: home_parent,
      children: [
        ...RouterTabRoutes,

        {
          path: '/system/app_function_console',
          name: 'app_function_console',
          component: resolve => {
            require(['@/components/system/app_function_console/index'], resolve)
          },
          meta: {
            title: "API控制台",
            tips: "API控制台"
          }

        },

        {
          path: '/home',
          name: 'home',
          component: home,
          meta: {
            title: "首页",
            tips: "首页"
          }

        },
        {
          path: '/system/menu_manage',
          name: 'menu_tree',
          component: resolve => {
            require(['@/components/system/menu_manage/index'], resolve)
          },
          meta: {
            title: "菜单栏管理",
            tips: "菜单栏管理",
            icon: "el-icon-omnis-setPlace"
          }
        },
        {
          path: '/system/role_manage',
          name: 'role_manage',
          component: resolve => {
            require(['@/components/system/role_manage/index'], resolve)
          },
          meta: {
            title: "角色管理",
            tips: "角色管理",
            icon: "el-icon-omnis-role"
          }
        },
        {
          path: '/system/role_apply',
          name: 'role_apply',
          component: resolve => {
            require(['@/components/system/role_apply/index'], resolve)
          },
          meta: {
            title: "角色申请",
            tips: "角色申请",
            icon: "el-icon-omnis-role"
          }
        },
        {
          path: '/system/role_approval',
          name: 'role_approval',
          component: resolve => {
            require(['@/components/system/role_approval/index'], resolve)
          },
          meta: {
            title: "角色审批",
            tips: "角色审批",
            icon: "el-icon-omnis-role"
          }
        },
        {
          path: '/system/user_management',
          name: 'user_management',
          component: resolve => {
            require(['@/components/system/user_management/index'], resolve)
          },
          meta: {
            title: "用户管理",
            tips: "用户管理",
            icon: "el-icon-omnis-yonghuguanli2"
          }
        },
        {
          path: '/sys/user_account',
          name: 'user_account_list',
          component: resolve => {
            require(['@/components/system/user_manage/index'], resolve)
          }
        },
        // {
        //   path: '/system/authority_management',
        //   name: 'authority_management',
        //   component: resolve => {
        //     require(['@/components/system/authority_management/index'], resolve)
        //   },
        //   meta: {
        //     title: "webshell权限组管理",
        //     tips: "text",
        //     icon: "el-icon-omnis-dapingfuwu"
        //   }
        // },
        {
          path: '/system/authority_organize_management',
          name: 'authority_organize_management',
          component: resolve => {
            require(['@/components/system/authority_management/authority_organize_management'], resolve)
          },
          meta: {
            title: "webshell权限",
            tips: "text",
            icon: "el-icon-omnis-91"
          }
        },
        {
          path: '/asset_operations/asset_area_management',
          name: 'asset_area_management',
          component: resolve => {
            require(['@/components/assets_operations/asset_area_management/index'], resolve)
          },
          meta: {
            title: "资源树管理",
            tips: "资源树管理",
            icon: "el-icon-omnis-zuzhi"
          }
        },
        {
          path: '/asset_operations/asset_management',
          name: 'asset_operations',
          component: resolve => {
            require(['@/components/assets_operations/asset_management/index'], resolve)
          },
          meta: {
            title: "主机管理",
            tips: "主机管理",
            icon: "el-icon-omnis-fuwuqi"
          }
        },
        {
          path: '/colony_operation/colony_resource',
          name: 'colony_resource',
          component: resolve => {
            require(['@/components/colony_operation/colony_resource/index'], resolve)
          },
          meta: {
            title: "K8s集群资源",
            tips: "K8s集群资源",
            icon: "el-icon-omnis-huanjing"
          }
        },
        {
          path: '/colony_operation/config_resource',
          name: 'config_resource',
          component: resolve => {
            require(['@/components/colony_operation/config_resource/index'], resolve)
          },
          meta: {
            title: "K8s配置资源",
            tips: "K8s配置资源",
            icon: "el-icon-omnis-ruanjianzhongxin"
          }
        },
        {
          path: '/colony_operation/apply_resource',
          name: 'apply_resource',
          component: resolve => {
            require(['@/components/colony_operation/apply_resource/index'], resolve)
          },
          meta: {
            title: "K8s应用资源",
            tips: "K8s应用资源",
            icon: "el-icon-omnis-huanjing"
          }
        },
        {
          path: '/colony_operation/apply_deploy',
          name: 'colony_operation',
          component: resolve => {
            require(['@/components/colony_operation/apply_deploy/index'], resolve)
          },
          meta: {
            title: "K8s应用部署",
            tips: "K8s应用部署",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/colony_operation/apply_deploy/:req_id',
          name: 'apply_deploy_req',
          component: resolve => {
            require(['@/components/colony_operation/apply_deploy/index'], resolve)
          },
          meta: {
            title: "K8s升级单部署",
            tips: "K8s升级单部署",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/colony_operation/apply_deploy/:req_id/:publish_req_rollback_event_id',
          name: 'apply_deploy_req_rollback',
          component: resolve => {
            require(['@/components/colony_operation/apply_deploy/index'], resolve)
          },
          meta: {
            title: "K8s升级单回退",
            tips: "K8s升级单回退",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/system/user_group_manage',
          name: 'user_group_manage',
          component: resolve => {
            require(['@/components/system/user_group_manage/index'], resolve)
          },
          meta: {
            title: "用户组管理",
            tips: "用户组管理",
            icon: "el-icon-omnis-yonghuzu"
          }
        },
        {
          path: '/system/label_manage',
          name: 'label_manage',
          component: resolve => {
            require(['@/components/system/label_manage/index'], resolve)
          },
          meta: {
            title: "标签管理",
            tips: "标签管理",
            icon: "el-icon-omnis-tianchongxing-"
          }
        },

        {
          path: '/asset_operations/env_init',
          name: 'env_init',
          component: resolve => {
            require(['@/components/assets_operations/env_init/index'], resolve)
          },
          meta: {
            title: "应用资源",
            tips: "应用资源",
            icon: "el-icon-omnis-huanjing"
          }
        },
        {
          path: '/asset_operations/app_resource',
          name: 'app_resource',
          component: resolve => {
            require(['@/components/assets_operations/app_resource/index'], resolve)
          },
          meta: {
            title: "应用资源new",
            tips: "应用资源new",
            icon: "el-icon-omnis-huanjing"
          }
        },
        {
          path: '/all_steps/one_steps',
          name: 'one_steps',
          component: resolve => {
            require(['@/components/assets_operations/env_init/all_steps/deployment_configuration'], resolve)
          },
          meta: {
            title: "添加部署配置",
            tips: "添加部署配置"
          }
        },
        {
          path: '/fort_service/webshell',
          name: 'webshell',
          component: resolve => {
            require(['@/components/webshell/index'], resolve)
          },
          meta: {
            title: "WEBSHELL",
            tips: "WEBSHELL"
          }
        },
        {
          path: '/asset_operations/asset_management_tmp',
          name: 'asset_operations_tmp',
          component: resolve => {
            require(['@/components/assets_operations/asset_management/asset_management_tmp'], resolve)
          },
          meta: {
            title: "组件示例",
            tips: "组件示例"
          }
        }
        ,
        {
          path: '/monitoring_center/monitoring_init_new',
          name: 'monitoring_center',
          component: resolve => {
            require(['@/components/monitoring_center/monitoring_init/monitor_init'], resolve)
          },
          meta: {
            title: "监控初始化",
            tips: "监控初始化",
            icon: "el-icon-omnis-ziyuanxhdpi"
          }
        },

        {
          path: '/monitoring_center/monitoring_init',
          name: 'monitoring_center',
          component: resolve => {
            require(['@/components/monitoring_center/monitoring_init/index'], resolve)
          },
          meta: {
            title: "监控初始化",
            tips: "监控初始化",
            icon: "el-icon-omnis-ziyuanxhdpi"
          }
        },
        {
          path: '/monitoring_center/knowledge_library',
          name: 'knowledge_library',
          component: resolve => {
            require(['@/components/monitoring_center/knowledge_library/index'], resolve)
          },
          meta: {
            title: '监控知识库',
            tips: "监控知识库",
            icon: "el-icon-omnis-zhishi"
          }
        },
        {
          path: '/system/sys_code',
          name: 'sys_code',
          component: resolve => {
            require(['@/components/system/sys_code/index'], resolve)
          },
          meta: {
            title: "码表管理",
            tips: "码表管理",
            icon: "el-icon-omnis-edge"
          }
        },
        {
          path: '/monitoring_center/common/external_router/:url?',
          name: 'external_router',
          props: true,
          component: resolve => {
            require(['@/components/monitoring_center/common/external_router'], resolve)
          },
          meta: {
            title: "监控配置管理",
            tips: "监控配置管理"
          }
        }, {
          path: '/webshell/webshell_blacklist',
          name: 'webshell_blacklist',
          component: resolve => {
            require(['@/components/webshell/webshell_blacklist/index'], resolve)
          },
          meta: {
            title: "webshell黑名单",
            tips: "webshell黑名单"
          }

        },
        {
          path: '/release_management/deploy_log',
          name: 'deploy_log',
          component: resolve => {
            require(['@/components/release_management/deploy_log/index'], resolve)
          },
          meta: {
            title: "部署日志",
            tips: "部署日志",
            icon: 'el-icon-omnis-rizhi',
          }
        }, {
          path: '/release_management/consheet_list',
          name: 'consheet_list',
          component: resolve => {
            require(['@/components/release_management/consheet_list/index'], resolve)
          },
          meta: {
            title: "升级单",
            tips: "升级单",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/release_management/deploy',
          name: 'deploy',
          component: resolve => {
            require(['@/components/release_management/deploy/index'], resolve)
          },
          meta: {
            title: "应用部署",
            tips: "应用部署",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/release_management/deploy/:req_id',
          name: 'deploy_req',
          component: resolve => {
            require(['@/components/release_management/deploy/index'], resolve)
          },
          meta: {
            title: "升级单部署",
            tips: "升级单部署",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/release_management/deploy/:req_id/:publish_req_rollback_event_id',
          name: 'deploy_req_rollback',
          component: resolve => {
            require(['@/components/release_management/deploy/index'], resolve)
          },
          meta: {
            title: "升级单回退",
            tips: "升级单回退",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/release_management/deploy_config/war_info_manage',
          name: 'war_info_manage',
          component: resolve => {
            require(['@/components/release_management/deploy_config/war_info_manage/index'], resolve)
          },
          meta: {
            title: "部署包基本信息管理",
            tips: "部署包基本信息管理"
          }
        },
        {
          path: '/release_management/deploy_config/param_config_group',
          name: 'param_config_group',
          component: resolve => {
            require(['@/components/release_management/deploy_config/param_config_group/index'], resolve)
          },
          meta: {
            title: "Global参数组",
            tips: "Global参数组"
          }
        },
        {
          path: '/release_management/base_software_deploy/software_conf_details',
          name: 'software_conf_details',
          component: resolve => {
            require(['@/components/release_management/base_software_deploy/software_conf_details/index'], resolve)
          },
          meta: {
            title: "软件参数管理",
            tips: "软件参数管理"
          }
        },
        {
          path: '/assets_operations/software_manage',
          name: 'software_manage',
          component: resolve => {
            require(['@/components/assets_operations/software_manage/index'], resolve)
          },
          meta: {
            title: "软件配置管理",
            tips: "软件配置管理"
          }
        },
        {
          path: '/efficient_devops/data_syn/data_import',
          name: 'data_import',
          component: resolve => {
            require(['@/components/efficient_devops/data_syn/data_import/index'], resolve)
          },
          meta: {
            title: "数据导入",
            tips: "数据导入",
            icon: "el-icon-omnis-shujudaoru"
          }
        },
        {
          path: '/efficient_devops/data_syn/data_export',
          name: 'data_export',
          component: resolve => {
            require(['@/components/efficient_devops/data_syn/data_export/index'], resolve)
          },
          meta: {
            title: "数据导出",
            tips: "数据导出",
            icon: "el-icon-omnis-shujudaochu"
          }
        },

        {
          path: '/efficient_devops/application_devops',
          name: 'application_devops',
          component: resolve => {
            require(['@/components/efficient_devops/application_devops/index'], resolve)
          },
          meta: {
            title: "软件运维",
            tips: "软件运维",
            icon: "el-icon-omnis-shujudaoru"
          }
        },

        {
          path: '/efficient_devops/application_devops/operation_log',
          name: 'soft_operation_log',
          component: resolve => {
            require(['@/components/efficient_devops/application_devops/operation-log'], resolve)
          },
          meta: {
            title: "软件运维日志",
            tips: "软件运维日志",
            icon: "el-icon-omnis-shujudaoru"
          }
        },

        {
          path: '/text',
          name: 'text',
          component: resolve => {
            require(['@/components/text'], resolve)
          },
          meta: {
            title: "text",
            tips: "text"
          }
        },
        {
          path: '/webshell/op_log',
          name: 'op_log',
          component: resolve => {
            require(['@/components/webshell/op_log'], resolve)
          },
          meta: {
            title: "操作日志",
            tips: "text"
          }
        },
        {
          path: '/system/web_config',
          name: 'web_config',
          component: resolve => {
            require(['@/components/system/web_config'], resolve)
          },
          meta: {
            title: "项目配置",
            tips: "text"
          }
        },
        {
          path: '/release_management/singlefile_version_management/singlefile_aggregation_management',
          name: 'singlefile_aggregation_management',
          component: resolve => {
            require(['@/components/release_management/singlefile_version_management/singlefile_aggregation_management/index'], resolve)
          },
          meta: {
            title: "单文件聚合管理",
            tips: "单文件聚合管理",
            icon: "el-icon-omnis-banben"
          }
        },
        {
          path: '/release_management/singlefile_version_management/singlefile_management',
          name: 'singlefile_management',
          component: resolve => {
            require(['@/components/release_management/singlefile_version_management/singlefile_management/index'], resolve)
          },
          meta: {
            title: "单文件管理",
            tips: "单文件管理",
            icon: "el-icon-omnis-xiangmu",


          }
        },
        {
          path: '/dev_ops/base_soft_manage',
          name: 'base_soft_manage',
          component: resolve => {
            require(['@/components/dev_ops/base_soft_manage'], resolve)
          },
          meta: {
            title: "基础软件管理",
            tips: "text"
          }
        },
        {
          path: '/monitoring_center/monitor_big_dish',
          name: 'monitor_big_dish',
          component: resolve => {
            require(['@/components/monitoring_center/monitor_big_dish/index'], resolve)
          },
          meta: {
            title: "监控大盘",
            tips: "text",
            icon: "el-icon-omnis-dapingfuwu"
          }
        },

        {
          path: '/monitoring_center/monitoring_history',
          name: 'monitoring_history',
          component: resolve => {
            require(['@/components/monitoring_center/monitoring_history/index'], resolve)
          },
          meta: {
            title: "监控历史信息",
            tips: "text",
            icon: "el-icon-omnis-lishi"
          }
        },
        {
          path: '/monitoring_center/main_panel',
          name: 'main_panel',
          component: resolve => {
            require(['@/components/monitoring_center/main_panel/index'], resolve)
          },
          meta: {
            title: "监控主面板",
            tips: "text",
            icon: "el-icon-omnis-zhediemianban"
          }
        },

        {
          path: '/monitoring_center/big_dish_manage',
          name: 'big_dish_manage',
          component: resolve => {
            require(['@/components/monitoring_center/monitor_big_dish_manage/index'], resolve)
          },
          meta: {
            title: "监控面板管理",
            tips: "text",
            icon: "el-icon-setting"
          }
        },
        {
          path: '/monitoring_center/big_dish_manage_new',
          name: 'big_dish_manage_new',
          component: resolve => {
            require(['@/components/monitoring_center/monitor_big_dish_manage/host_panel'], resolve)
          },
          meta: {
            title: "监控面板管理new",
            tips: "text",
            icon: "el-icon-setting"
          }
        },
        {
          path: '/message_center/message_passage',
          name: 'message_passage',
          component: resolve => {
            require(['@/components/message_center/message_passage/index'], resolve)
          },
          meta: {
            title: "消息通道管理",
            tips: "消息通道管理",
            icon: "el-icon-omnis-jiagetongdaoxian"
          }
        },
        {
          path: '/message_center/send_list',
          name: 'send_list',
          component: resolve => {
            require(['@/components/message_center/send_list/index'], resolve)
          },
          meta: {
            title: "消息发送列表",
            tips: "消息发送列表",
            icon: "el-icon-omnis-xiaoxi3"
          }
        }, {
          path: '/message_center/message_rule',
          name: 'message_rule',
          component: resolve => {
            require(['@/components/message_center/message_rule/index'], resolve)
          },
          meta: {
            title: "消息规则管理",
            tips: "消息规则管理",
            icon: "el-icon-omnis-guize",
          }
        },

        {
          path: '/message_center/message_temporary_forbidden',
          name: 'message_temporary_forbidden',
          component: resolve => {
            require(['@/components/message_center/message_temporary_forbidden/index'], resolve)
          },
          meta: {
            title: "消息临时禁用发送",
            tips: "消息临时禁用发送",
            icon: "el-icon-omnis-linshigongzuo",
          }
        },
        {
          path: '/message_center/message_send_token',
          name: 'message_send_token',
          component: resolve => {
            require(['@/components/message_center/message_send_token/index'], resolve)
          },
          meta: {
            title: "令牌消息",
            tips: "令牌消息",
            icon: "el-icon-omnis-lingpai"
          }
        },

        {
          path: '/message_center/msg_sendchannel_provider',
          name: 'msg_sendchannel_provider',
          component: resolve => {
            require(['@/components/message_center/msg_sendchannel_provider/index'], resolve)
          },
          meta: {
            title: "消息提供者",
            tips: "消息提供者",
            icon: "el-icon-omnis-zhongguohangtiantubiaoheji-weizhuanlunkuo-"
          }
        },
        {
          path: '/system/label_manage/test',
          name: 'test_file',
          component: resolve => {
            require(['@/components/system/label_manage/test'], resolve)
          },
          meta: {
            title: "文件上传",
            tips: "文件上传"
          }
        },
        {
          path: '/release_management/file_synchronization/intermediate_server',
          name: 'intermediate_server',
          component: resolve => {
            require(['@/components/release_management/file_synchronization/intermediate_server/index'], resolve)
          },
          meta: {
            title: "中间服务器同步",
            tips: "中间服务器同步",
            icon: "el-icon-omnis-zhongjianguanli"
          }
        },
        {
          path: '/release_management/file_synchronization/intranet_server',
          name: 'intranet_server',
          component: resolve => {
            require(['@/components/release_management/file_synchronization/intranet_server/index'], resolve)
          },
          meta: {
            title: "内网服务器同步",
            tips: "内网服务器同步",
            icon: "el-icon-omnis-neiwang"
          }
        },
        {
          path: '/release_management/file_synchronization/synchronize_setting',
          name: 'synchronize_setting',
          component: resolve => {
            require(['@/components/release_management/file_synchronization/synchronize_setting/index'], resolve)
          },
          meta: {
            title: "同步策略设置",
            tips: "同步策略设置"
          }
        },
        {
          path: '/release_management/oracle_lock',
          name: 'oracle_lock',
          component: resolve => {
            require(['@/components/release_management/oracle_lock/index'], resolve)
          },
          meta: {
            title: "Oracle 查锁",
            tips: "Oracle 查锁",
            icon: "el-icon-omnis-jiesuo"
          }
        },
        {
          path: '/efficient_devops/data_syn/sync_standard',
          name: 'db_sync_standard',
          component: resolve => {
            require(['@/components/efficient_devops/data_syn/sync_standard/index'], resolve)
          },
          meta: {
            title: "同步标准",
            tips: "同步标准",
            icon: "el-icon-omnis-biaozhun-copy"
          }
        }, {
          path: '/fort_service/websql_audit',
          name: 'websql_audit',
          component: resolve => {
            require(['@/components/fort_service/websql_audit/index'], resolve)
          },
          meta: {
            title: "WEBSQL 审计",
            tips: "WEBSQL 审计",
            icon: "el-icon-omnis-dbauditshujukushenji"
          }
        }, {
          path: '/fort_service/websql',
          name: 'websql',
          component: resolve => {
            require(['@/components/fort_service/websql/index'], resolve)
          },
          meta: {
            title: "WEBSQL ",
            tips: "WEBSQL",
            icon: "el-icon-omnis-yunshujuku"
          }
        },

        {
          path: '/fort_service/websql/websql_permission',
          name: 'websql_permission',
          component: resolve => {
            require(['@/components/fort_service/websql/websql_permission'], resolve)
          },
          meta: {
            title: "WEBSQL权限",
            tips: "WEBSQL权限",
            icon: "el-icon-omnis-yunshujuku"
          }
        },

        {
          path: '/monitoring_center/monitoring_templates',
          name: 'monitoring_templates',
          component: resolve => {
            require(['@/components/monitoring_center/monitoring_templates/index'], resolve)
          },
          meta: {
            title: "监控模板管理",
            tips: "监控模板管理",
            icon: "el-icon-goods"
          }
        },

        {
          path: '/monitoring_center/active_dial_test_new',
          name: 'active_dial_test_new',
          icon: "el-icon-s-ticket",
          component: resolve => {
            require(['@/components/monitoring_center/active_dial_test/index_page'], resolve)
          },
          meta: {
            title: "主动拨测",
            tips: "主动拨测",
            icon: "el-icon-omnis-ziyuanxhdpi"
          }
        },
        {
          path: '/efficient_devops/oracle_report',
          name: 'oracle_report',
          component: resolve => {
            require(['@/components/efficient_devops/oracle_report/index'], resolve)
          },
          meta: {
            title: "Oracle报告生成",
            tips: "Oracle报告生成",
            icon: "el-icon-omnis-baogao2"
          }
        },
        {
          path: '/efficient_devops/oracle_check_assess',
          name: 'oracle_check_assess',
          component: resolve => {
            require(['@/components/efficient_devops/oracle_check_assess/index'], resolve)
          },
          meta: {
            title: "Oracle巡检与评估",
            tips: "Oracle巡检与评估",
            icon: "el-icon-omnis-jiancha"
          }
        },
        {
          path: '/efficient_devops/oracle_sql_analyze',
          name: 'oracle_sql_analyze',
          component: resolve => {
            require(['@/components/efficient_devops/oracle_sql_analyze/index'], resolve)
          },
          meta: {
            title: "OracleSQL分析",
            tips: "OracleSQL分析",
            icon: "el-icon-omnis-fenxi"
          }
        },

        {
          path: '/release_management/publish_req_detail',
          name: 'publish_req_detail',
          component: resolve => {
            require(['@/components/release_management/publish_req_detail/index'], resolve)
          },
          meta: {
            title: "项目升级明细",
            tips: "项目升级明细",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/system/sys_token',
          name: 'sys_token',
          component: resolve => {
            require(['@/components/system/sys_token/index'], resolve)
          },
          meta: {
            title: "令牌管理",
            tips: "令牌管理",
            icon: "el-icon-omnis-zhongduanzaixianshengji"
          }
        },
        {
          path: '/efficient_devops/custom_tasks',
          redirect: '/efficient_devops/addTasks',
          name: 'custom_tasks',
          component: resolve => {
            require(['@/components/efficient_devops/custom_tasks/index'], resolve)
          },
          meta: {
            title: "自定义任务",
            tips: "自定义任务",
            icon: "el-icon-omnis-shujudaoru"
          },
          children: [
            {
              path: '/efficient_devops/addTasks',
              name: 'custom_tasks',
              component: resolve => {
                require(['@/components/efficient_devops/custom_tasks/addTasks'], resolve)
              },
            },
            {
              path: '/efficient_devops/performTasks',
              name: 'custom_tasks',
              component: resolve => {
                require(['@/components/efficient_devops/custom_tasks/performTasks'], resolve)
              },
            },
            {
              path: '/efficient_devops/tasksList',
              name: 'custom_tasks',
              component: resolve => {
                require(['@/components/efficient_devops/custom_tasks/tasksList'], resolve)
              },
            },
            {
              path: '/efficient_devops/scriptLibrary',
              name: 'custom_tasks',
              component: resolve => {
                require(['@/components/efficient_devops/custom_tasks/scriptLibrary'], resolve)
              },
            },
          ]
        },





      ]
    },
    {
      path: '/*',
      name: '404_page',
      component: resolve => {
        require(['@/components/system/common/404_page'], resolve)
      },
      meta: {
        title: "404-对不起！您访问的页面不存在",
        tips: "404-对不起！您访问的页面不存在",
        icon: "el-icon-omnis-fenxi"
      }
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js